import { NavigationService } from './../../../../core/services/navigation.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-job-left-panel',
  templateUrl: './job-left-panel.component.html',
  styleUrls: ['./job-left-panel.component.scss'],
})
export class JobLeftPanelComponent implements OnInit {
  properties = [
    {
      name: 'Jobs',
      routerLink: 'Jobs',
      spanClass: 'bi bi-briefcase',
    },
    {
      name: 'Queue',
      routerLink: 'Queue',
      spanClass: 'bi bi-list-ol',
    },
    {
      name: 'Templates',
      routerLink: 'Templates',
      spanClass: 'bi bi-journal-code',
    },
    {
      name: 'Logs',
      routerLink: 'Logs',
      spanClass: 'bi bi-body-text',
    },
  ];

  selectedIndex: number;

  constructor(private navService: NavigationService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.navService.index.subscribe(x => {
      this.selectedIndex = x;
    })
  }

  sendData(index: number, property) {
    this.selectedIndex = index;
    this.navService.sendLeftPanelIndex(this.selectedIndex);
    this.navService.sendParentData(property.name);
    this.router.navigate([property.routerLink], { relativeTo: this.route })
    this.navService.selectedLogType = "Job";
  }
}
